// Texas Pool Code Compliance Ranges
export const COMPLIANCE_RANGES = {
  ph: { min: 7.2, max: 7.8, label: 'pH' },
  chlorine: { min: 2, max: 4, label: 'Chlorine (ppm)' },
  total_chlorine: { min: 1.0, max: null, label: 'Total Chlorine (ppm)' },
  calcium_hardness: { min: 200, max: 400, label: 'Calcium Hardness (ppm)' },
  alkalinity: { min: 80, max: 120, label: 'Alkalinity (ppm)' },
  cyanuric_acid: { min: 30, max: 50, label: 'Cyanuric Acid (ppm)' },
};

export const checkCompliance = (parameter, value) => {
  const range = COMPLIANCE_RANGES[parameter];
  if (!range) return { status: 'none', message: '' };
  
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return { status: 'none', message: '' };
  
  if (range.min !== null && numValue < range.min) {
    return {
      status: 'low',
      message: `Too low (min: ${range.min})`,
      color: 'text-amber-600 bg-amber-50 border-amber-200'
    };
  }
  
  if (range.max !== null && numValue > range.max) {
    return {
      status: 'high',
      message: `Too high (max: ${range.max})`,
      color: 'text-red-600 bg-red-50 border-red-200'
    };
  }
  
  return {
    status: 'compliant',
    message: 'Within range',
    color: 'text-green-600 bg-green-50 border-green-200'
  };
};

export const getReadingStatus = (reading) => {
  const checks = [
    checkCompliance('ph', reading.ph),
    checkCompliance('chlorine', reading.chlorine),
    checkCompliance('calcium_hardness', reading.calcium_hardness),
    checkCompliance('alkalinity', reading.alkalinity),
    checkCompliance('cyanuric_acid', reading.cyanuric_acid),
  ];
  
  const hasLow = checks.some(c => c.status === 'low');
  const hasHigh = checks.some(c => c.status === 'high');
  
  if (hasLow || hasHigh) {
    return {
      compliant: false,
      status: hasHigh ? 'high' : 'low',
      issues: checks.filter(c => c.status !== 'compliant' && c.status !== 'none')
    };
  }
  
  return {
    compliant: true,
    status: 'compliant',
    issues: []
  };
};
